/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strength_Level_ExperiencedInputs */

const en_strength_level_experienced = /** @type {(inputs: Strength_Level_ExperiencedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experienced`)
};

const pl_strength_level_experienced = /** @type {(inputs: Strength_Level_ExperiencedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doświadczenie`)
};

/**
* | output |
* | --- |
* | "Experienced" |
*
* @param {Strength_Level_ExperiencedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const strength_level_experienced = /** @type {((inputs?: Strength_Level_ExperiencedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strength_Level_ExperiencedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_strength_level_experienced(inputs)
	return en_strength_level_experienced(inputs)
});